import { filterSuggestionItems } from '@blocknote/core/extensions';
import { SuggestionMenuController } from '@blocknote/react';
import { getSlashMenuItems } from '~/modules/common/blocknote/blocknote-config';
import { CustomSlashMenuComponent } from '~/modules/common/blocknote/custom-slash-menu/custom-slash-menu';
import type { CustomBlockNoteMenuProps } from '~/modules/common/blocknote/types';

export function CustomSlashMenu({ editor, allowedTypes, headingLevels, titleLevel }: CustomBlockNoteMenuProps) {
  const slashMenuItems = getSlashMenuItems(editor, allowedTypes, headingLevels, titleLevel);

  return (
    <SuggestionMenuController
      triggerCharacter={'/'}
      getItems={async (query) => filterSuggestionItems(slashMenuItems, query)}
      suggestionMenuComponent={(props) => (
        <CustomSlashMenuComponent {...props} originalItemCount={slashMenuItems.length} allowedTypes={allowedTypes} />
      )}
    />
  );
}
